import cmp from './AcceptedBidDetails'

export default cmp
